var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('badge',{attrs:{"type":_vm.getBadgeType()}},[_vm._v(_vm._s(_vm.statusesOptions[_vm.invoice.status]))])}
var staticRenderFns = []

export { render, staticRenderFns }